import React from "react";
import styles from "./Style.module.css";
import DashboardSnackbar from "../../../components/Snackbar.component";
import classNames from "classnames";
import logoImage from "../../../assets/CRMAssets/psconnect_login_logo@2x.png";
import { IconButton, ButtonBase, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useLoginHook from "./Login.hook";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import CaptchaComponent from "../component/CaptchaComponent";
import { useSelector } from "react-redux";

function LoginView() {
  const theme = useTheme();
  const { domainTheme } = useSelector((state) => state.app_setting);
  const {
    handleSubmit,
    onBlurHandler,
    changeTextData,
    form,
    errorData,
    togglePasswordVisibility,
    showPassword,
  } = useLoginHook();

  const bgUrl = domainTheme?.background_image;
  const logoUrl = domainTheme?.display_logo || logoImage;

  return (
    <div className={"login"} style={{ backgroundImage: bgUrl ? `url(${bgUrl})` : undefined, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className={styles.overlay}></div>
      <div className={styles.mainLoginView}></div>
      <div className={styles.container}>
        <div className={styles.loginFlex2}>
          <div className={styles.logoImageData}>
            <img src={logoUrl} alt="text_data" style={{ width: "250px" }} />
          </div>
          <div className={styles.signContainer}>
            <div className={styles.loginHeaderText}>
              <Typography variant="h3">Welcome to psConnect</Typography>

              <Typography
                variant={"body1"}
                sx={{ color: theme?.palette?.text?.secondary }}
              >
                Enter the details below to login to your account
              </Typography>
            </div>

            <div className={styles.formContainer}>
              <div className={styles.formFlexGrouup}>
                <div className={"formGroup"}>
                  <CustomTextField
                    isError={errorData?.email}
                    errorText={errorData?.email}
                    label={
                      <>Email ID
                      <span style={{ color: theme.palette.error.main }}>*</span>
                      </>
                    }
                    value={form?.email}
                    onTextChange={(text) => {
                      changeTextData(text, "email");
                    }}
                    onBlur={() => {
                      onBlurHandler("email");
                    }}
                  />
                </div>
              </div>
              <div className={styles.formFlexGrouup}>
                <div className={"formGroup"}>
                  <div style={{ display: "flex", marginTop: "8px" }}>
                    <CustomTextField
                      type={showPassword ? "text" : "password"}
                      isError={errorData?.password}
                      errorText={errorData?.password}
                      label={
                      <>Password
                      <span style={{ color: theme.palette.error.main }}>*</span>
                      </>}
                      value={form?.password}
                      onTextChange={(text) => {
                        changeTextData(text, "password");
                      }}
                      onBlur={() => {
                        onBlurHandler("password");
                      }}
                    />

                    <IconButton
                      className={styles.visibleIcon}
                      onClick={togglePasswordVisibility}
                    >
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            
            <div className={styles.logFlex}>
              <div className={classNames(styles.negativeSpacing, "log")}>
              <CaptchaComponent  handleSubmit={handleSubmit}/>
              </div>
            </div>

          </div>
        </div>
        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default LoginView;
